import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import {
  Provider
} from 'react-redux'
import {
  BrowserRouter as Router
} from 'react-router-dom';
import {
  createMuiTheme,
  MuiThemeProvider
} from '@material-ui/core/styles';
import {
  configureStore
} from 'configure';
//import registerServiceWorker from './registerServiceWorker';

const store = configureStore.createStore();
const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#720038'
    }
  }
});

ReactDOM.render(
  <Router>
    <Provider store={store}>
      <MuiThemeProvider theme={theme}>
        <App />
      </MuiThemeProvider>
    </Provider>
  </Router>,
  document.getElementById('root')
);

configureStore.runSagas();
//registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js